import {
  KYDBlockData,
  KYDCampaignEvent,
  KYDEmailTemplate,
  KYDEventBlockData,
  KYDEventListItemData,
} from 'interfaces/KYDCampaign';

export const DEFAULT_EVENT_DATA: KYDCampaignEvent = {
  id: '',
  name: 'Event Name',
  image: '',
  start_at: '',
  end_at: '',
  link: '',
  is_external: false,
  venue: undefined,
};

export const DEFAULT_EVENT_LIST_ITEM_DATA: KYDEventListItemData = {
  id: undefined,
  event: DEFAULT_EVENT_DATA,
  subcopy: '',
};

export const DEFAULT_EVENT_BLOCK_DATA: KYDEventBlockData = {
  id: undefined,
  event: DEFAULT_EVENT_DATA,
  custom_image: '',
  button_text: 'Buy Tickets',
  door_time: '',
  show_time: '',
  body: '',
};

export const TEMPLATE_BLOCKS: Partial<KYDEmailTemplate>[] = [
  {
    type: 'WEEKLY_NEWSLETTER',
    version: 1,
    name: 'Weekly Newsletter',
    description: 'Weekly - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'eventList',
        events: [DEFAULT_EVENT_LIST_ITEM_DATA],
      },
      {
        type: 'event1col',
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
    ] as KYDBlockData[],
  },
  {
    type: 'WEEKLY_PRESS_EMAIL',
    version: 1,
    name: 'Weekly Press Email',
    description: 'Weekly - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'eventList',
        events: [DEFAULT_EVENT_LIST_ITEM_DATA],
      },
      {
        type: 'event1col',
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
    ] as KYDBlockData[],
  },
  {
    type: 'LATE_NIGHTS',
    version: 2,
    name: 'Late Nights',
    description: 'Late Nights - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
      {
        type: 'event2col',
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: 'LATE_NIGHTS',
    version: 2,
    name: 'Late Nights',
    description: 'Late Nights - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
      {
        type: 'event2col',
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: 'LATE_NIGHTS',
    version: 1,
    name: 'Late Nights',
    description: 'Late Nights - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [],
      },
      {
        type: 'event2col',
        events: [],
      },
    ] as KYDBlockData[],
  },
  {
    type: 'EVENT_ANNOUNCEMENT',
    version: 2,
    name: 'Event Announcement',
    description: 'Event Announcement - Single event listing',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
      {
        type: 'image',
        src: '',
      },
    ] as KYDBlockData[],
  },
  {
    type: 'EVENT_ANNOUNCEMENT',
    version: 1,
    name: 'Event Announcement',
    description: 'Event Announcement - Single event listing',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [],
      },
      {
        type: 'image',
        src: '',
      },
    ] as KYDBlockData[],
  },
  {
    type: 'PRESALE_EVENT_MULTIPLE',
    version: 1,
    name: 'Presale Event Multiple',
    description: 'Presale Event - Single event listing',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Presale',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [],
      },
      {
        type: 'video',
        src: '',
      },
    ] as KYDBlockData[],
  },
  {
    type: 'PRESALE_EVENT_MULTIPLE',
    version: 2,
    name: 'Presale Event Multiple',
    description: 'Presale Event - Single event listing',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Presale',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
      {
        type: 'video',
        src: '',
      },
    ] as KYDBlockData[],
  },
  {
    type: 'PRESS_RELEASE_MULTIPLE',
    version: 2,
    name: 'Press Release Multiple',
    description: 'Press Release Multiple - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Press Release',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: 'PRESS_RELEASE_MULTIPLE',
    version: 1,
    name: 'Press Release Multiple',
    description: 'Press Release Multiple - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Press Release',
        link_headline_to_event: false,
      },
      {
        type: 'event2col',
        events: [],
      },
    ] as KYDBlockData[],
  },
  {
    type: 'GENRE_GROUPED_EVENTS',
    version: 2,
    name: 'Genre Grouped Events',
    description: 'Genre Grouped Events - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'event1col',
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
      {
        type: 'event2col',
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: 'GENRE_GROUPED_EVENTS',
    version: 1,
    name: 'Genre Grouped Events',
    description: 'Genre Grouped Events - Multiple event listings',
    blocks: [
      {
        type: 'textHeadline',
        headline: 'LPR Weekly',
        link_headline_to_event: false,
      },
      {
        type: 'event1col',
        event: {},
      },
      {
        type: 'event2col',
        events: [],
      },
    ] as KYDBlockData[],
  },
  {
    type: 'BLANK_TEMPLATE',
    version: 1,
    name: 'Blank Template',
    description: 'Use blocks to build your own',
    blocks: [],
  },
];
